export const medals = [
  {
     "Medal":"Silver",
     "Games":"1960 Rome",
     "Sport":"Athletics",
     "Event":"Men's decathlon",
     "Gender":"Men",
     "n":1,
     "Year":1960,
     "id":1,
     "Medal_zh":"銀牌",
     "Games_zh":"1960年羅馬",
     "Sport_zh":"田徑",
     "Event_zh":"男子十項全能",
     "Gender_zh":"男子"
  },
  {
     "Medal":"Bronze",
     "Games":"1968 Mexico City",
     "Sport":"Athletics",
     "Event":"Women's 80 metre hurdles",
     "Gender":"Women",
     "n":1,
     "Year":1968,
     "id":2,
     "Medal_zh":"銅牌",
     "Games_zh":"1968年墨西哥城",
     "Sport_zh":"田徑",
     "Event_zh":"女子80公尺跨欄",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Bronze",
     "Games":"1984 Los Angeles",
     "Sport":"Weightlifting",
     "Event":"Men's 60 kg",
     "Gender":"Men",
     "n":1,
     "Year":1984,
     "id":3,
     "Medal_zh":"銅牌",
     "Games_zh":"1984年洛杉磯",
     "Sport_zh":"舉重",
     "Event_zh":"男子60公斤級",
     "Gender_zh":"男子"
  },
  {
     "Medal":"Silver",
     "Games":"1992 Barcelona",
     "Sport":"Baseball",
     "Event":"Men's competition",
     "Gender":"Men",
     "n":1,
     "Year":1992,
     "id":4,
     "Medal_zh":"銀牌",
     "Games_zh":"1992年巴塞隆納",
     "Sport_zh":"棒球",
     "Event_zh":"男子棒球",
     "Gender_zh":"男子"
  },
  {
     "Medal":"Silver",
     "Games":"1996 Atlanta",
     "Sport":"Table tennis",
     "Event":"Women's singles",
     "Gender":"Women",
     "n":1,
     "Year":1996,
     "id":5,
     "Medal_zh":"銀牌",
     "Games_zh":"1996年亞特蘭大",
     "Sport_zh":"乒乓球",
     "Event_zh":"女子單打",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Silver",
     "Games":"2000 Sydney",
     "Sport":"Weightlifting",
     "Event":"Women's 53 kg",
     "Gender":"Women",
     "n":1,
     "Year":2000,
     "id":6,
     "Medal_zh":"銀牌",
     "Games_zh":"2000年雪梨",
     "Sport_zh":"舉重",
     "Event_zh":"女子53公斤級",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Bronze",
     "Games":"2000 Sydney",
     "Sport":"Table tennis",
     "Event":"Women's singles",
     "Gender":"Women",
     "n":1,
     "Year":2000,
     "id":7,
     "Medal_zh":"銅牌",
     "Games_zh":"2000年雪梨",
     "Sport_zh":"乒乓球",
     "Event_zh":"女子單打",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Bronze",
     "Games":"2000 Sydney",
     "Sport":"Taekwondo",
     "Event":"Women's 49 kg",
     "Gender":"Women",
     "n":1,
     "Year":2000,
     "id":8,
     "Medal_zh":"銅牌",
     "Games_zh":"2000年雪梨",
     "Sport_zh":"跆拳道",
     "Event_zh":"女子49公斤以下級",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Bronze",
     "Games":"2000 Sydney",
     "Sport":"Taekwondo",
     "Event":"Men's 58 kg",
     "Gender":"Men",
     "n":1,
     "Year":2000,
     "id":9,
     "Medal_zh":"銅牌",
     "Games_zh":"2000年雪梨",
     "Sport_zh":"跆拳道",
     "Event_zh":"男子58公斤以下級",
     "Gender_zh":"男子"
  },
  {
     "Medal":"Bronze",
     "Games":"2000 Sydney",
     "Sport":"Weightlifting",
     "Event":"Women's 75 kg",
     "Gender":"Women",
     "n":1,
     "Year":2000,
     "id":10,
     "Medal_zh":"銅牌",
     "Games_zh":"2000年雪梨",
     "Sport_zh":"舉重",
     "Event_zh":"女子75公斤級",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Gold",
     "Games":"2004 Athens",
     "Sport":"Taekwondo",
     "Event":"Women's flyweight",
     "Gender":"Women",
     "n":1,
     "Year":2004,
     "id":11,
     "Medal_zh":"金牌",
     "Games_zh":"2004年雅典",
     "Sport_zh":"跆拳道",
     "Event_zh":"女子49公斤級",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Gold",
     "Games":"2004 Athens",
     "Sport":"Taekwondo",
     "Event":"Men's flyweight",
     "Gender":"Men",
     "n":1,
     "Year":2004,
     "id":12,
     "Medal_zh":"金牌",
     "Games_zh":"2004年雅典",
     "Sport_zh":"跆拳道",
     "Event_zh":"男子58公斤級",
     "Gender_zh":"男子"
  },
  {
     "Medal":"Silver",
     "Games":"2004 Athens",
     "Sport":"Archery",
     "Event":"Men's team",
     "Gender":"Men",
     "n":1,
     "Year":2004,
     "id":13,
     "Medal_zh":"銀牌",
     "Games_zh":"2004年雅典",
     "Sport_zh":"射箭",
     "Event_zh":"男子團體",
     "Gender_zh":"男子"
  },
  {
     "Medal":"Silver",
     "Games":"2004 Athens",
     "Sport":"Taekwondo",
     "Event":"Men's lightweight",
     "Gender":"Men",
     "n":1,
     "Year":2004,
     "id":14,
     "Medal_zh":"銀牌",
     "Games_zh":"2004年雅典",
     "Sport_zh":"跆拳道",
     "Event_zh":"男子68公斤級",
     "Gender_zh":"男子"
  },
  {
     "Medal":"Bronze",
     "Games":"2004 Athens",
     "Sport":"Archery",
     "Event":"Women's team",
     "Gender":"Women",
     "n":1,
     "Year":2004,
     "id":15,
     "Medal_zh":"銅牌",
     "Games_zh":"2004年雅典",
     "Sport_zh":"射箭",
     "Event_zh":"女子團體",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Gold",
     "Games":"2008 Beijing",
     "Sport":"Weightlifting",
     "Event":"Women's 48 kg",
     "Gender":"Women",
     "n":1,
     "Year":2008,
     "id":16,
     "Medal_zh":"金牌",
     "Games_zh":"2008年北京",
     "Sport_zh":"舉重",
     "Event_zh":"女子48公斤級",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Silver",
     "Games":"2008 Beijing",
     "Sport":"Weightlifting",
     "Event":"Women's 63 kg",
     "Gender":"Women",
     "n":1,
     "Year":2008,
     "id":17,
     "Medal_zh":"銀牌",
     "Games_zh":"2008年北京",
     "Sport_zh":"舉重",
     "Event_zh":"女子63公斤級",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Bronze",
     "Games":"2008 Beijing",
     "Sport":"Taekwondo",
     "Event":"Men's 58 kg",
     "Gender":"Men",
     "n":1,
     "Year":2008,
     "id":18,
     "Medal_zh":"銅牌",
     "Games_zh":"2008年北京",
     "Sport_zh":"跆拳道",
     "Event_zh":"男子58公斤級",
     "Gender_zh":"男子"
  },
  {
     "Medal":"Bronze",
     "Games":"2008 Beijing",
     "Sport":"Taekwondo",
     "Event":"Men's 68 kg",
     "Gender":"Men",
     "n":1,
     "Year":2008,
     "id":19,
     "Medal_zh":"銅牌",
     "Games_zh":"2008年北京",
     "Sport_zh":"跆拳道",
     "Event_zh":"男子68公斤級",
     "Gender_zh":"男子"
  },
  {
     "Medal":"Gold",
     "Games":"2012 London",
     "Sport":"Weightlifting",
     "Event":"Women's 53 kg",
     "Gender":"Women",
     "n":1,
     "Year":2012,
     "id":20,
     "Medal_zh":"金牌",
     "Games_zh":"2012年倫敦",
     "Sport_zh":"舉重",
     "Event_zh":"女子53公斤級",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Bronze",
     "Games":"2012 London",
     "Sport":"Taekwondo",
     "Event":"Women's 57 kg",
     "Gender":"Women",
     "n":1,
     "Year":2012,
     "id":21,
     "Medal_zh":"銅牌",
     "Games_zh":"2012年倫敦",
     "Sport_zh":"跆拳道",
     "Event_zh":"女子57公斤級",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Gold",
     "Games":"2016 Rio de Janeiro",
     "Sport":"Weightlifting",
     "Event":"Women's 53 kg",
     "Gender":"Women",
     "n":1,
     "Year":2016,
     "id":22,
     "Medal_zh":"金牌",
     "Games_zh":"2016年里約熱內盧",
     "Sport_zh":"舉重",
     "Event_zh":"女子53公斤級",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Bronze",
     "Games":"2016 Rio de Janeiro",
     "Sport":"Archery",
     "Event":"Women's team",
     "Gender":"Women",
     "n":1,
     "Year":2016,
     "id":23,
     "Medal_zh":"銅牌",
     "Games_zh":"2016年里約熱內盧",
     "Sport_zh":"射箭",
     "Event_zh":"女子團體",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Bronze",
     "Games":"2016 Rio de Janeiro",
     "Sport":"Weightlifting",
     "Event":"Women's 58 kg",
     "Gender":"Women",
     "n":1,
     "Year":2016,
     "id":24,
     "Medal_zh":"銅牌",
     "Games_zh":"2016年里約熱內盧",
     "Sport_zh":"舉重",
     "Event_zh":"女子58公斤級",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Gold",
     "Games":"2020 Tokyo",
     "Sport":"Weightlifting",
     "Event":"Women's 59 kg",
     "Gender":"Women",
     "n":1,
     "Year":2020,
     "id":25,
     "Medal_zh":"金牌",
     "Games_zh":"2020年東京",
     "Sport_zh":"舉重",
     "Event_zh":"女子59公斤級",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Gold",
     "Games":"2020 Tokyo",
     "Sport":"Badminton",
     "Event":"Men's doubles",
     "Gender":"Men",
     "n":1,
     "Year":2020,
     "id":26,
     "Medal_zh":"金牌",
     "Games_zh":"2020年東京",
     "Sport_zh":"羽球",
     "Event_zh":"男子雙打",
     "Gender_zh":"男子"
  },
  {
     "Medal":"Silver",
     "Games":"2020 Tokyo",
     "Sport":"Judo",
     "Event":"Men's 60 kg",
     "Gender":"Men",
     "n":1,
     "Year":2020,
     "id":27,
     "Medal_zh":"銀牌",
     "Games_zh":"2020年東京",
     "Sport_zh":"柔道",
     "Event_zh":"男子60公斤級",
     "Gender_zh":"男子"
  },
  {
     "Medal":"Silver",
     "Games":"2020 Tokyo",
     "Sport":"Archery",
     "Event":"Men's team",
     "Gender":"Men",
     "n":1,
     "Year":2020,
     "id":28,
     "Medal_zh":"銀牌",
     "Games_zh":"2020年東京",
     "Sport_zh":"射箭",
     "Event_zh":"男子團體",
     "Gender_zh":"男子"
  },
  {
     "Medal":"Silver",
     "Games":"2020 Tokyo",
     "Sport":"Gymnastics",
     "Event":"Men's pommel horse",
     "Gender":"Men",
     "n":1,
     "Year":2020,
     "id":29,
     "Medal_zh":"銀牌",
     "Games_zh":"2020年東京",
     "Sport_zh":"體操",
     "Event_zh":"男子鞍馬",
     "Gender_zh":"男子"
  },
  {
     "Medal":"Silver",
     "Games":"2020 Tokyo",
     "Sport":"Badminton",
     "Event":"Women's singles",
     "Gender":"Women",
     "n":1,
     "Year":2020,
     "id":30,
     "Medal_zh":"銀牌",
     "Games_zh":"2020年東京",
     "Sport_zh":"羽球",
     "Event_zh":"女子單打",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Bronze",
     "Games":"2020 Tokyo",
     "Sport":"Taekwondo",
     "Event":"Women's 57 kg",
     "Gender":"Women",
     "n":1,
     "Year":2020,
     "id":31,
     "Medal_zh":"銅牌",
     "Games_zh":"2020年東京",
     "Sport_zh":"跆拳道",
     "Event_zh":"女子57公斤級",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Bronze",
     "Games":"2020 Tokyo",
     "Sport":"Table tennis",
     "Event":"Mixed doubles",
     "Gender":"Mixed",
     "n":1,
     "Year":2020,
     "id":32,
     "Medal_zh":"銅牌",
     "Games_zh":"2020年東京",
     "Sport_zh":"乒乓球",
     "Event_zh":"混合雙打",
     "Gender_zh":"混合"
  },
  {
     "Medal":"Bronze",
     "Games":"2020 Tokyo",
     "Sport":"Weightlifting",
     "Event":"Women's 64 kg",
     "Gender":"Women",
     "n":1,
     "Year":2020,
     "id":33,
     "Medal_zh":"銅牌",
     "Games_zh":"2020年東京",
     "Sport_zh":"舉重",
     "Event_zh":"女子64公斤級",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Bronze",
     "Games":"2020 Tokyo",
     "Sport":"Golf",
     "Event":"Men's individual",
     "Gender":"Men",
     "n":1,
     "Year":2020,
     "id":34,
     "Medal_zh":"銅牌",
     "Games_zh":"2020年東京",
     "Sport_zh":"高爾夫",
     "Event_zh":"男子個人",
     "Gender_zh":"男子"
  },
  {
     "Medal":"Bronze",
     "Games":"2020 Tokyo",
     "Sport":"Boxing",
     "Event":"Women's flyweight",
     "Gender":"Women",
     "n":1,
     "Year":2020,
     "id":35,
     "Medal_zh":"銅牌",
     "Games_zh":"2020年東京",
     "Sport_zh":"拳擊",
     "Event_zh":"女子51公斤級",
     "Gender_zh":"女子"
  },
  {
     "Medal":"Bronze",
     "Games":"2020 Tokyo",
     "Sport":"Karate",
     "Event":"Women's 55 kg",
     "Gender":"Women",
     "n":1,
     "Year":2020,
     "id":36,
     "Medal_zh":"銅牌",
     "Games_zh":"2020年東京",
     "Sport_zh":"空手道",
     "Event_zh":"女子55公斤級",
     "Gender_zh":"女子"
  },
  {
    Medal: "Bronze",
    Games: "2024 Paris",
    Sport: "Gymnastics",
    Event: "Men's Horizontal Bar",
    Gender: "Men",
    n: 1,
    Year: 2024,
    id: 37,
    "Medal_zh":"銅牌",
    "Games_zh":"2024年巴黎",
    "Sport_zh":"體操",
    "Event_zh":"男子單槓",
    "Gender_zh":"男子"
  },
  {
    Medal: "Gold",
    Games: "2024 Paris",
    Sport: "Badminton",
    Event: "Men's Doubles",
    Gender: "Men",
    n: 1,
    Year: 2024,
    id: 38,
    "Medal_zh":"金牌",
    "Games_zh":"2024年巴黎",
    "Sport_zh":"羽球",
    "Event_zh":"男子雙打",
    "Gender_zh":"男子"
  },
  {
    Medal: "Gold",
    Games: "2024 Paris",
    Sport: "Boxing",
    Event: "Women's 57kg",
    Gender: "Women",
    n: 1,
    Year: 2024,
    id: 39,
    "Medal_zh":"金牌",
    "Games_zh":"2024年巴黎",
    "Sport_zh":"拳擊",
    "Event_zh":"女子羽量級（57公斤級）",
    "Gender_zh":"女子"
  },
  {
    Medal: "Bronze",
    Games: "2024 Paris",
    Sport: "Boxing",
    Event: "Women's 60kg",
    Gender: "Women",
    n: 1,
    Year: 2024,
    id: 40,
    "Medal_zh":"銅牌",
    "Games_zh":"2024年巴黎",
    "Sport_zh":"拳擊",
    "Event_zh":"女子輕量級（60公斤級）",
    "Gender_zh":"女子"
  },
  {
    Medal: "Bronze",
    Games: "2024 Paris",
    Sport: "Boxing",
    Event: "Women's 66kg",
    Gender: "Women",
    n: 1,
    Year: 2024,
    id: 41,
    "Medal_zh":"銅牌",
    "Games_zh":"2024年巴黎",
    "Sport_zh":"拳擊",
    "Event_zh":"女子次中量級（66公斤級）",
    "Gender_zh":"女子"
  },
  {
    Medal: "Bronze",
    Games: "2024 Paris",
    Sport: "Shooting",
    Event: "Skeet Men",
    Gender: "Men",
    n: 1,
    Year: 2024,
    id: 42,
    "Medal_zh":"銅牌",
    "Games_zh":"2024年巴黎",
    "Sport_zh":"射擊",
    "Event_zh":"男子定向飛靶",
    "Gender_zh":"男子"
  },
  {
    Medal: "Bronze",
    Games: "2024 Paris",
    Sport: "Weightlifting",
    Event: "Women's 59kg",
    Gender: "Women",
    n: 1,
    Year: 2024,
    id: 43,
    "Medal_zh":"銅牌",
    "Games_zh":"2024年巴黎",
    "Sport_zh":"舉重",
    "Event_zh":"女子59公斤級",
    "Gender_zh":"女子"
  },
];
